<template>
  <div class="__option-item">
    <CTooltip
      position="bottom close"
      :message="$t('No supported yet')"
      :hidden="!data.disabled"
      block
    >
      <div
        class="box"
        :class="{ active: data.usageType === value, disabled: data.disabled }"
        @click="clickSelector(data.usageType)"
        :key="data.usageType"
      >
        <div class="icon">
          <CIcon :name="data.icon" material />
        </div>
        <div>
          <span class="text-center text-sm">{{ data.label }}</span>
        </div>
      </div>
    </CTooltip>
  </div>
</template>

<script>
import Vue from 'vue';

import CIcon from '@/components/uikit/CIcon/index';
import CTooltip from '@/components/uikit/CTooltip/index';

const messages = {
  messages: {
    en: {
      'No supported yet': 'No supported yet',
    },
    ja: {
      'No supported yet': '現在ご利用いただけません',
    },
  },
};

export default Vue.extend({
  name: 'OptionItem',
  i18n: messages,
  components: { CIcon, CTooltip },
  props: {
    value: String,
    data: Object,
  },
  data() {
    return {
      active: 'account',
    };
  },
  methods: {
    clickSelector(type) {
      this.$emit('click', type);
    },
  },
});
</script>

<style lang="scss" scoped>
.__option-item {
  width: 100%;

  .box {
    width: 100%;
    text-align: center;
    padding-bottom: $padding-sm;
    cursor: pointer;

    &:hover {
      color: $primary-color;
      transform: translateY(-1px) scale(1.01);
      transition-duration: 300ms;
    }

    &.active {
      color: $primary-color;
    }

    &.disabled {
      cursor: default;

      &:hover {
        color: rgba($neutral-color, 0.4);
      }
    }

    .icon {
      font-size: 1.75rem;
    }
  }
}
</style>
